import GridLayout from '../GridLayout';
import createInfiniteWindowedLayout from '../createInfiniteWindowedLayout';
import { calculateIndexesForInfiniteGrid } from '../../shared/infinite.utils';
import { getGridDataFromProps } from '../../shared';

const calculateGridIndexes = (gridData, useOverscanForLoading) => {
  return calculateIndexesForInfiniteGrid(gridData, useOverscanForLoading);
};

export default createInfiniteWindowedLayout({
  getLayoutDataProps: getGridDataFromProps,
  calculateLayoutIndexes: calculateGridIndexes,
})(GridLayout);
